import { Action, on } from '@ngrx/store';
import { cloneDeep } from 'lodash';
import { createImmerReducer } from 'ngrx-immer/store';
import * as ComputersStatisticActions from './actions';
import { ComputersStatisticState, initialComputersStatisticModel, initialComputersStatisticState } from './state';

const reducer = createImmerReducer(
  initialComputersStatisticState,
  on(ComputersStatisticActions.loadStatistic, (state, action): ComputersStatisticState => {
    if ((!action.force && state.statisticLoaded) || action.silent) return state;

    state.statisticLoading = true;

    return state;
  }),
  on(ComputersStatisticActions.loadStatisticSuccess, (state, action): ComputersStatisticState => {
    state.statistic = action.data;
    state.statisticLoaded = true;
    state.statisticLoading = false;

    return state;
  }),
  on(ComputersStatisticActions.loadStatisticError, (state): ComputersStatisticState => {
    state.statistic = cloneDeep(initialComputersStatisticModel);

    return state;
  }),

  on(ComputersStatisticActions.clear, (): ComputersStatisticState => {
    return cloneDeep(initialComputersStatisticState);
  }),

  on(ComputersStatisticActions.checkOneComputerExist, (state, action): ComputersStatisticState => {
    if (state.oneComputerExistLoaded && !action.force) return state;

    state.oneComputerExistLoading = true;

    return state;
  }),
  on(ComputersStatisticActions.checkOneComputerSuccess, (state, action): ComputersStatisticState => {
    state.oneComputerExist = action.data;
    state.oneComputerExistLoading = false;
    state.oneComputerExistLoaded = true;

    return state;
  }),
  on(ComputersStatisticActions.checkOneComputerError, (state): ComputersStatisticState => {
    state.oneComputerExist = false;
    state.oneComputerExistLoading = false;
    state.oneComputerExistLoaded = false;

    return state;
  })
);

export function computersStatisticReducer(state: ComputersStatisticState | undefined, action: Action) {
  return reducer(state, action);
}
